import {StyledRadioBoxItem, StyledRadioBoxItemInput} from '@/components/ui/radio-box-atoms/style'
import {Item, ToggleGroupItemProps} from '@radix-ui/react-toggle-group'
import {ReactNode} from 'react'

export const RadioBoxItem = (props: ToggleGroupItemProps & {children: ReactNode; error?: boolean}) => {
    const {children, error, ...rest} = props

    return (
        <StyledRadioBoxItem {...rest} $hasError={error}>
            <Item {...rest} asChild>
                <StyledRadioBoxItemInput type="radio" />
            </Item>
            {children}
        </StyledRadioBoxItem>
    )
}
